// Safely turns plain http/https URLs inside guide-body text into clickable anchors WITHOUT
// introducing raw HTML: text is still rendered as React strings, only detected URL substrings
// become <a> elements. The displayed link text is the URL exactly as written. External links open
// in a new tab with rel="noopener noreferrer"; internal HotelStrips links stay same-tab.
const URL_RE = /(https?:\/\/[^\s<>()]+[^\s<>().,!?;:'"])/g;

const INTERNAL_HOSTS = ["hotelstrips.com", "www.hotelstrips.com"];

function isInternal(url) {
  try {
    const host = new URL(url).hostname.toLowerCase();
    const current = typeof window !== "undefined" ? window.location.hostname.toLowerCase() : "";
    return INTERNAL_HOSTS.includes(host) || (!!current && host === current);
  } catch {
    return false;
  }
}

export function Linkify({ text }) {
  if (!text) return null;
  // String.split with a single capturing group keeps the URLs: even indices are prose, odd are URLs.
  const parts = String(text).split(URL_RE);
  return parts.map((part, i) => {
    if (i % 2 === 1) {
      const external = !isInternal(part);
      return (
        <a
          key={i}
          href={part}
          data-testid="guide-body-link"
          className="text-primary underline underline-offset-2 hover:text-primary/80 break-words"
          {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
        >
          {part}
        </a>
      );
    }
    return part;
  });
}
